import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES,
  selectedRequestSelector,
  setCoursePauseRequestedRequestUpdateModalStage,
  useCancelRequestMutation,
} from 'features/courseResume';

function CancelRequestButton() {
  const dispatch = useDispatch();
  const [
    cancelRequest,
    { isSuccess: isCancelledSuccesfully, error, isLoading: isCancelling },
  ] = useCancelRequestMutation();
  const selectedRequest = useSelector(selectedRequestSelector);

  useEffect(() => {
    if (isCancelledSuccesfully) {
      dispatch(
        setCoursePauseRequestedRequestUpdateModalStage(
          COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.success
        )
      );
    }
  }, [dispatch, isCancelledSuccesfully]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  const handleCancel = useCallback(() => {
    if (isCancelling) return;

    cancelRequest({
      requestId: selectedRequest.id,
    });
  }, [selectedRequest, cancelRequest, isCancelling]);

  return (
    <Tappable
      disabled={isCancelling}
      onClick={handleCancel}
      className="btn btn-secondary btn-small"
    >
      Cancel Request
    </Tappable>
  );
}

export default CancelRequestButton;
